import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getMeasurementFrequencyList as getMeasurementFrequencyListApi,
	getMeasurementFrequencyListQuery as getMeasurementFrequencyListQueryApi,
	getMeasurementFrequency as getMeasurementFrequencyApi,
	addNewMeasurementFrequencyApi,
	updateMeasurementFrequencyApi,
	deleteMeasurementFrequencyApi,
	checkMeasurementFrequencyExistsApi,
} from '../../helpers/measurement_frequency/api_helper';

export const getMeasurementFrequencyList = createAsyncThunk(
	'measurementFrequency/getMeasurementFrequencyList',
	async () => {
		try {
			const response = await getMeasurementFrequencyListApi();
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las frecuencias de medición.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getMeasurementFrequencyListQuery = createAsyncThunk(
	'measurementFrequency/getMeasurementFrequencyListQuery',
	async params => {
		try {
			const response = getMeasurementFrequencyListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getMeasurementFrequency = createAsyncThunk(
	'measurementFrequency/getMeasurementFrequency',
	async measurement_frequency_id => {
		try {
			const response = await getMeasurementFrequencyApi(measurement_frequency_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la frecuencia de medición.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewMeasurementFrequency = createAsyncThunk(
	'measurementFrequency/addNewMeasurementFrequency',
	async measurement_frequency => {
		try {
			const response = await addNewMeasurementFrequencyApi(measurement_frequency);
			toast.success('Frecuencia de Medición agregada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la frecuencia de medición.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateMeasurementFrequency = createAsyncThunk(
	'measurementFrequency/updateMeasurementFrequency',
	async measurement_frequency => {
		try {
			const response = await updateMeasurementFrequencyApi(measurement_frequency);
			toast.success('Frecuencia de Medición actualizada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la frecuencia de medición.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteMeasurementFrequency = createAsyncThunk(
	'measurementFrequency/deleteMeasurementFrequency',
	async measurement_frequency => {
		try {
			await deleteMeasurementFrequencyApi(measurement_frequency._id);
			toast.success('Frecuencia de Medición eliminada exitosamente.', {
				autoClose: 3000,
			});
			return measurement_frequency;
		} catch (error) {
			toast.error('Error al eliminar la frecuencia de medición.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkMeasurementFrequencyExists = createAsyncThunk(
	'measurementFrequency/checkMeasurementFrequencyExists',
	async name => {
		try {
			const response = await checkMeasurementFrequencyExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
